import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: eprivacy
 * Version: 7.3.0-ALPHA-3
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import React from 'react';
import { getPurposes } from '../utils/config';
var ConsentNotice = /*#__PURE__*/function (_React$Component) {
  function ConsentNotice() {
    _classCallCheck(this, ConsentNotice);
    return _callSuper(this, ConsentNotice, arguments);
  }
  _inherits(ConsentNotice, _React$Component);
  return _createClass(ConsentNotice, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        config = _this$props.config,
        manager = _this$props.manager,
        isModalVisible = _this$props.isModalVisible,
        isMandatory = _this$props.isMandatory,
        t = _this$props.t,
        ns = _this$props.ns,
        onSaveRequest = _this$props.onSaveRequest,
        onDeclineRequest = _this$props.onDeclineRequest,
        onConfigRequest = _this$props.onConfigRequest;
      var purposes = getPurposes(config);
      var purposesText = purposes.map(function (purpose) {
        return t(['purposes', purpose]);
      }).join(', ');
      var title = t(['consentNotice', 'title']);
      var linkDeclineText = t(['consentNotice', 'declineLinkText']);
      var RenderHTML = function RenderHTML(props) {
        return /*#__PURE__*/React.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: props.HTML
          }
        });
      };
      return /*#__PURE__*/React.createElement("div", {
        "aria-hidden": isModalVisible,
        className: ns("Notice".concat(isMandatory ? ' Notice--mandatory' : ''))
      }, config.declineLink && linkDeclineText && /*#__PURE__*/React.createElement("a", {
        className: ns('Notice-link-decline'),
        href: "#",
        onClick: onDeclineRequest
      }, linkDeclineText), /*#__PURE__*/React.createElement("div", {
        className: ns('Notice-body')
      }, config.logo && /*#__PURE__*/React.createElement("div", {
        className: ns('Notice-logoContainer')
      }, /*#__PURE__*/React.createElement("img", {
        src: _typeof(config.logo) == 'object' ? config.logo.src : config.logo,
        alt: _typeof(config.logo) == 'object' && config.logo.alt ? config.logo.alt : '',
        className: ns('Notice-logo')
      })), /*#__PURE__*/React.createElement("div", {
        className: ns('Notice-text')
      }, title && /*#__PURE__*/React.createElement("h1", {
        className: ns('Notice-title'),
        id: "orejime-notice-title",
        dangerouslySetInnerHTML: {
          __html: title
        }
      }), /*#__PURE__*/React.createElement("p", {
        className: ns('Notice-description')
      }, /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: t(['consentNotice', 'description'])
        }
      }), t(['consentNotice', 'privacyPolicy', 'text'], {
        privacyPolicy: /*#__PURE__*/React.createElement("a", {
          target: "_blank",
          key: "privacyPolicyLink",
          className: ns('Notice-privacyPolicyLink'),
          href: config.privacyPolicy,
          dangerouslySetInnerHTML: {
            __html: t(['consentNotice', 'privacyPolicy', 'name'])
          }
        })
      }))), manager.changed && /*#__PURE__*/React.createElement("p", {
        className: ns('Notice-changes')
      }, t(['consentNotice', 'changeDescription'])), /*#__PURE__*/React.createElement("ul", {
        className: ns('Notice-actions')
      }, /*#__PURE__*/React.createElement("li", {
        className: ns('Notice-actionItem Notice-actionItem--save')
      }, /*#__PURE__*/React.createElement("button", {
        className: ns('Button Button--save Notice-button Notice-saveButton'),
        type: "button",
        title: t(['acceptTitle']),
        onClick: onSaveRequest
      }, t(['accept']))), !(config.declineLink && linkDeclineText) && /*#__PURE__*/React.createElement("li", {
        className: ns('Notice-actionItem Notice-actionItem--decline')
      }, /*#__PURE__*/React.createElement("button", {
        className: ns('Button Button--decline Notice-button Notice-declineButton'),
        type: "button",
        onClick: onDeclineRequest
      }, t(['decline']))), /*#__PURE__*/React.createElement("li", {
        className: ns('Notice-actionItem Notice-actionItem--info')
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: ns('Button Button--info Notice-learnMoreButton'),
        onClick: onConfigRequest
      }, t(['consentNotice', 'learnMore']))))));
    }
  }]);
}(React.Component);
export { ConsentNotice as default };